export default __webpack_public_path__ + "static/media/haste.1c1054f3.png";